import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import './Settings.css'

export default function Settings() {
  const navigate = useNavigate()
  const { user } = useAuthStore()
  const isAdmin = user?.role === 'admin' || user?.role === 'TenantAdmin'

  if (!isAdmin) {
    return (
      <div className="settings-page">
        <h1>הגדרות</h1>
        <p className="settings-no-access">You do not have permission to access this page.</p>
      </div>
    )
  }

  return (
    <div className="settings-page">
      <h1>הגדרות</h1>
      <div className="settings-cards">

        <div className="settings-card">
          <div className="settings-card-icon">👥</div>
          <div className="settings-card-body">
            <h3>ניהול משתמשים</h3>
            <p>צור, ערוך והגדר משתמשים ותפקידים במערכת.</p>
            <button className="btn-primary" onClick={() => navigate('/settings/user-management')}>
              User Management
            </button>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-icon">🏢</div>
          <div className="settings-card-body">
            <h3>הגדרת לקוחות</h3>
            <p>צור ונהל רשומות לקוחות, פרטי חברה ומידע רישוי.</p>
            <button className="btn-primary" onClick={() => navigate('/settings/customer-setup')}>
              Customer Setup
            </button>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-icon">🔑</div>
          <div className="settings-card-body">
            <h3>רישיונות</h3>
            <p>נהל רישיונות מערכת, מפתחות ותכונות מורשות.</p>
            <button className="btn-primary" onClick={() => navigate('/settings/licenses')}>
              Licenses
            </button>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-icon">📋</div>
          <div className="settings-card-body">
            <h3>לוגים תפעוליים</h3>
            <p>תיעוד פעולות, בקרה ידנית ואירועי מערכת.</p>
            <button className="btn-primary" onClick={() => navigate('/settings/logs')}>
              Operations Log
            </button>
          </div>
        </div>

      </div>
    </div>
  )
}
